import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faDownload, faMoneyCheck } from '@fortawesome/free-solid-svg-icons';
import { getCurrentDate } from '../../utils/dateUtils';
import EditStudentPopup from './EditStudentPopup';

const StudentTable = ({
  data,
  loading,
  selectedColumns,
  getAllColumns,
  openPaymentModal,
  openInvoiceModal,
  hasAccess,
  onStudentUpdate,
}) => {
  const currentDate = getCurrentDate();
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  if (loading) {
    return <div className="loading-indicator">Loading...</div>;
  }

  if (data.length === 0) {
    return <div className="no-records">No records found</div>;
  }

  const handleEditClick = (student) => {
    setSelectedStudent(student);
    setShowEditPopup(true);
  };

  const closeEditPopup = () => {
    setShowEditPopup(false);
    setSelectedStudent(null);
  };

  const handleStudentUpdate = (updatedStudent) => {
    if (onStudentUpdate) {
      onStudentUpdate(updatedStudent);
    }
    closeEditPopup();
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              {getAllColumns()
                .filter(column => selectedColumns.includes(column.key))
                .map(column => (
                  <th key={column.key}>{column.label}</th>
                ))
              }
              {hasAccess && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const isFeesZero = parseFloat(item.pendingFees || 0) === 0 &&
                parseFloat(item.pendingFees2 || 0) === 0 &&
                parseFloat(item.pendingFees3 || 0) === 0 &&
                parseFloat(item.pendingFees4 || 0) === 0;

              // Check if either pendingFeesDate or pendingFeesDate2 is today
              const isPendingToday =
                item.pendingFeesDate === currentDate ||
                item.pendingFeesDate2 === currentDate ||
                item.pendingFeesDate3 === currentDate ||
                item.pendingFeesDate4 === currentDate;

              // Check if either pendingFeesDate or pendingFeesDate2 is overdue
              const isOverdue =
                (item.pendingFeesDate && new Date(item.pendingFeesDate) < new Date(currentDate)) ||
                (item.pendingFeesDate2 && new Date(item.pendingFeesDate2) < new Date(currentDate)) ||
                (item.pendingFeesDate3 && new Date(item.pendingFeesDate3) < new Date(currentDate)) ||
                (item.pendingFeesDate4 && new Date(item.pendingFeesDate4) < new Date(currentDate));

              // Ensure we prioritize the most important status
              let rowClassName = '';
              if (item.studentProgressStatus === 'In Active') {
                rowClassName = 'inactive-row'; // 👈 new class for In Active
              } else if (isFeesZero) {
                rowClassName = 'paid-fees';
              } else if (isOverdue) {
                rowClassName = 'overdue-fees';
              } else if (isPendingToday) {
                rowClassName = 'due-today';
              }


              return (
                <tr
                  key={item.studentId || item.id || item._id || index}
                  className={rowClassName}
                >
                  {getAllColumns()
                    .filter(column => selectedColumns.includes(column.key))
                    .map(column => (
                      <td key={column.key}>
                        {item[column.key]}
                      </td>
                    ))
                  }
                  {hasAccess && (
                    <td>
                      <button onClick={() => openPaymentModal(item)} className="edit-btn">
                        <FontAwesomeIcon icon={faMoneyCheck} />
                      </button>

                      <button onClick={() => handleEditClick(item)} className="edit-btn" title="Edit Student">
                        <FontAwesomeIcon icon={faEdit} />
                      </button>

                      <button onClick={() => openInvoiceModal(item)} className="download1-btn">
                        <FontAwesomeIcon icon={faDownload} />
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <EditStudentPopup
        isOpen={showEditPopup}
        student={selectedStudent}
        onClose={closeEditPopup}
        onSave={handleStudentUpdate}
      />
    </div>
  );
};

export default StudentTable;